 <div class="card p-3 m-3 main-card">
  <div class="card-body main-body p-0">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 col-xxl-3">
        <div class="row">
          <div class="col col-xxl-10">
            <div class="mb-3">
              <label class="form-label" i18n>User name</label>
              <input type="text" [(ngModel)]="UserName" class="form-control" placeholder="User name">
            </div>
            <div class="mb-3">
              <label class="form-label" i18n>Password</label>
              <input type="password" [(ngModel)]="Password" class="form-control" placeholder="Password">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <button (click)="login()" class="btn btn-primary">Login</button>
          <button routerLink="/forgotpassword" class="btn btn-link float-end" i18n>Forgot password?</button>
        </div>
      </div>
    </div>
  </div>
</div>